import type { IAccountNotificationsPreferences } from './AccountNotificationsPreferences.interface';

export default class AccountNotificationsPreferences
  implements IAccountNotificationsPreferences {
  le: boolean;
  se: boolean;
  ee: boolean;
  es: boolean;

  static build = (data: IAccountNotificationsPreferences) =>
    new AccountNotificationsPreferences(data);

  static blank = () => new AccountNotificationsPreferences();

  /**
   * Constructor
   * @param {IAccountNotificationsPreferences} data
   */
  constructor(data?: IAccountNotificationsPreferences) {
    this.le = data?.le === true;
    this.se = data?.se === true;
    this.ee = data?.ee === true;
    this.es = data?.es === true;
  }
}
